import React, { memo, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import { site } from "../../../_foundation/constants/site";

// interface SkeletonLoaderProps {
//   hideSkeletonLoader?: boolean;
//   skeletonLoaderHeight?: string | number;
//   skeletonVariant?: "circular" | "rectangular" | "rounded";
// }

interface ImageProps {
  src: string;
  alt?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  transparent?: boolean;
  styles?: React.CSSProperties;
  priority?: boolean;
}

const ImageComponent: React.FC<ImageProps> = ({
  src,
  alt = "",
  className,
  width,
  height,
  transparent,
  styles = {},
  priority = false,
  // hideSkeletonLoader = false,
  // skeletonLoaderHeight,
  // skeletonVariant,
}) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isLoadError, setIsLoadError] = useState<boolean>(false);
  const isBotCrawling = window?.["__isPrerender__"] || false;
  const finalSrc = !isBotCrawling && isLoadError ? site.defaultImage : src;

  return (
    <>
      {/* {!hideSkeletonLoader && !loaded && (
        <Skeleton
          variant={skeletonVariant || "rectangular"}
          className="skeleton_loader"
          animation="wave"
          sx={{
            margin: "0 auto",
            width: width || "100%",
            height: skeletonLoaderHeight || height || "100%",
          }}>
          {width === "100%" && <div style={{ paddingTop: "100%" }} />}
        </Skeleton>
      )} */}

      <img
        className={className}
        src={finalSrc}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding={priority ? "sync" : "async"}
        style={{
          margin: "0 auto",
          display: "block",
          objectFit: "cover",
          opacity: transparent ? 0 : 1,
          width,
          height,
          ...styles,
        }}
        onLoad={() => setLoaded(true)}
        onError={() => setIsLoadError(true)}
        {...({ fetchPriority: priority ? "high" : "auto" } as any)}
      />
    </>
  );
};

export const ImageLayout = memo(ImageComponent);
